import {
  APP_MANAGED_ROUTES,
  BackgroundInformationModal,
  HsaPage,
  LegalPage,
  MODAL_PARAMS,
  QUERY_PARAM_KEYS,
} from '@highmark-web/highmark-common';
import { Navigate, RouteObject } from '@leagueplatform/routing';
import { HomePage, SupportPage } from 'components/lazy-routes.component';
import openHsaImage from 'assets/hsa/open-hsa.svg';
import hsaAccountCreatedImage from 'assets/hsa/hsa-account-created.svg';
import { AboutBeneficity } from 'pages/settings/about-beneficity.page';

export const StandaloneRoutes: RouteObject[] = [
  { path: `${APP_MANAGED_ROUTES.ABOUT}/*`, element: <AboutBeneficity /> },
  {
    path: `${APP_MANAGED_ROUTES.ABOUT_BENEFICITY}/*`,
    element: <Navigate to={APP_MANAGED_ROUTES.ABOUT} replace />,
  },
  {
    path: `${APP_MANAGED_ROUTES.BACKGROUND_INFORMATION}/*`,
    element: <BackgroundInformationModal />,
  },
  {
    path: APP_MANAGED_ROUTES.HOME,
    element: <HomePage />,
  },
  {
    path: APP_MANAGED_ROUTES.HSA_ENROLLMENT,
    element: (
      <HsaPage
        openHsaImage={openHsaImage}
        hsaAccountCreatedImage={hsaAccountCreatedImage}
      />
    ),
  },
  { path: `${APP_MANAGED_ROUTES.LEGAL}/*`, element: <LegalPage /> },
  {
    path: APP_MANAGED_ROUTES.EBILL,
    element: (
      <Navigate
        to={`${APP_MANAGED_ROUTES.HOME}?${QUERY_PARAM_KEYS.modal}=${MODAL_PARAMS.EBILL_REGISTRATION}`}
        replace
      />
    ),
  },
  {
    path: APP_MANAGED_ROUTES.SUPPORT,
    element: <SupportPage />,
  },
];
